var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"pt-2 mb-4 bg-purple-50 rounded border border-purple-200 p-2"},[_c('div',{staticClass:"text-xs"},[_vm._v("Selected quants: "+_vm._s(_vm.cartItemIds.join(', ')))]),_c('div',{staticClass:"text-xs"},[_vm._v("Warehouse: "+_vm._s(_vm.cartWarehouse))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }